export default __webpack_public_path__ + "static/media/bar-vehicle-memory.be1a9bf8.svg";